import React from 'react';
import PropTypes from 'prop-types';
import { Avatar, Icon, Tooltip } from 'antd';
import classNames from 'classnames';

import { openUrlInNewTab } from '../../data/config/utils';
import { IconSuccess, IconCrossCircle, IconFacebookSquare, IconTwitterSquare, IconLinkedinSquare } from '../../data/assets/icons';
import { IMG_USER } from '../../data/assets/img';

class AvatarCard extends React.PureComponent {
    onClickFacebookIcon = () => {
        openUrlInNewTab(this.props.facebook_url);
    };

    onClickTwitterIcon = () => {
        openUrlInNewTab(this.props.twitter_url);
    };

    onClickLinkedinIcon = () => {
        openUrlInNewTab(this.props.linkedin_url);
    };

    render() {
        const { hide_avatar, container_class, avatar_class, image_url, title, title_class, sub_title_class, icon_class, mobile, email, sub_title, sub_title2, show_status, is_verified, is_active, is_deleted, bio, show_sociallinks, facebook_url, linkedin_url, twitter_url, onClickAvatar } = this.props;

        return (
            <div className={container_class}>
                {
                    !hide_avatar &&
                    <div className="ori-flex-row ori-flex-jc ori-b-pad-15">
                        <div className={classNames("ori-animated ori-fade-in", { "ori-cursor-ptr": onClickAvatar })} onClick={onClickAvatar}>
                            <Avatar icon="user" src={image_url && image_url.trim().length > 0 ? image_url : IMG_USER} shape="square" className={avatar_class} />
                        </div>
                    </div>
                }
                {
                    title &&
                    <p className={`ori-font-bold ori-uppercase ${title_class}`}>{title}</p>
                }
                {
                    sub_title &&
                    <p className={sub_title_class}>{sub_title}</p>
                }
                {
                    sub_title2 &&
                    <p className={sub_title_class}>{sub_title2}</p>
                }
                {
                    mobile &&
                    <p className={sub_title_class}>
                        <Icon type="phone" className={`ori-r-mrgn-3 ori-rotate-120 ${icon_class}`} />
                        <span>{mobile}</span>
                    </p>
                }
                {
                    email &&
                    <p className={sub_title_class}>
                        <Icon type="mail" className={`ori-r-mrgn-3 ${icon_class}`} />
                        <span>{email}</span>
                    </p>
                }
                {
                    show_status &&
                    <div className="ori-t-pad-15 ori-flex-row ori-flex-jsa ori-flex-wrap">
                        <AvatarStatus title="VERIFIED" status={is_verified} font_active_class="ori-font-primary" />
                        <AvatarStatus title="ACTIVE" status={is_active} font_active_class="ori-font-green" />
                        <AvatarStatus title="DELETED" status={is_deleted} font_active_class="ori-font-danger" />
                    </div>
                }
                {
                    bio && bio.trim().length > 0 &&
                    <div className="ori-text-center ori-pad-10">
                        <span className="ori-font-15 ori-line-height-1">&ldquo; {bio} &rdquo;</span>
                    </div>
                }
                {
                    show_sociallinks &&
                    <div className="">
                        <p className="ori-text-center ori-font-light ori-font-xs">You can follow me on</p>
                        <div className="ori-flex-row ori-flex-jc ori-flex-wrap">
                            <Tooltip title={facebook_url}>
                                <div className={classNames("ori-pad-5 ", { "ori-cursor-ptr ori-font-facebook": facebook_url && facebook_url.trim().length > 0 })} onClick={this.onClickFacebookIcon}><IconFacebookSquare size={24} /></div>
                            </Tooltip>
                            <Tooltip title={twitter_url}>
                                <div className={classNames("ori-pad-5", { "ori-cursor-ptr ori-font-twitter": twitter_url && twitter_url.trim().length > 0 })} onClick={this.onClickTwitterIcon}><IconTwitterSquare size={24} /></div>
                            </Tooltip>
                            <Tooltip title={linkedin_url}>
                                <div className={classNames("ori-pad-5", { "ori-cursor-ptr ori-font-linkedin": linkedin_url && linkedin_url.trim().length > 0 })} onClick={this.onClickLinkedinIcon}><IconLinkedinSquare size={24} /></div>
                            </Tooltip>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

const AvatarStatus = (props) => {
    const { title, status, font_active_class } = props;
    return (
        <div className={classNames("ori-tb-mrgn-5", { [font_active_class]: status, "ori-font-light": !status })}>
            {
                status &&
                <IconSuccess size={16} />
            }
            {
                !status &&
                <IconCrossCircle size={16} />
            }
            <span className="ori-lr-pad-5 ori-uppercase ori-line-height-1 ori-font-13">{title}</span>
        </div>
    );
}

AvatarStatus.propTypes = {
    title: PropTypes.string,
    status: PropTypes.bool,
    font_active_class: PropTypes.string,
};

AvatarCard.propTypes = {
    container_class: PropTypes.string,
    avatar_class: PropTypes.string,
    email: PropTypes.string,
    image_url: PropTypes.string,
    title: PropTypes.string,
    mobile: PropTypes.string,
    sub_title: PropTypes.string,
    sub_title2: PropTypes.string,
    show_status: PropTypes.bool,
    title_class: PropTypes.string,
    sub_title_class: PropTypes.string,
    icon_class: PropTypes.string,
    is_verified: PropTypes.bool,
    is_active: PropTypes.bool,
    is_deleted: PropTypes.bool,
    bio: PropTypes.string,
    show_sociallinks: PropTypes.bool,
    facebook_url: PropTypes.string,
    twitter_url: PropTypes.string,
    linkedin_url: PropTypes.string,
    hide_avatar: PropTypes.bool,
    onClickAvatar: PropTypes.func,
};

AvatarCard.defaultProps = {
    container_class: "ori-tb-pad-10",
    title_class: "ori-text-center",
    sub_title_class: "ori-text-center ori-font-xs ori-font-light",
    avatar_class: "ori-box-65",
    show_status: false,
    icon_class: "ori-font-xxs",
    is_verified: false,
    is_active: false,
    is_deleted: false,
    show_sociallinks: false,
    hide_avatar: false,
};

export default AvatarCard;



// WEBPACK FOOTER //
// ./src/components/avatarcard/index.js